import type { ReactNode, CSSProperties } from 'react'
import Color from 'color'
import styled, { css } from 'styled-components'

const colors = {
  green: '#6BDBB1',
  red: '#FF9186',
  yellow: '#FABF5E',
  blue: '#2A5EF6',
}

export type LabelColor = keyof typeof colors

interface LabelWrapperProps {
  color?: LabelColor
  children: ReactNode
  style?: CSSProperties
}

export const LabelWrapper = styled(({ color, ...rest }: LabelWrapperProps) => (
  <div {...rest} />
))`
  ${({ color = 'blue' }) => css`
    border: 1px solid ${colors[color]};
    color: ${colors[color]};
    background: ${Color(colors[color]).alpha(0.1).string()};
    padding: 4px 12px;
    border-radius: 31px;
    white-space: nowrap;
    display: inline-flex;
    cursor: default;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  `}
`
